import type { Components, Theme } from '@mui/material/styles';

import { varAlpha } from 'minimal-shared/utils';

// ----------------------------------------------------------------------

const MuiPaper: Components<Theme>['MuiPaper'] = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { elevation: 0 },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: {
      position: 'relative',
      backgroundImage: 'none',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-16px',
        right: '-16px',
        width: '80px',
        height: '80px',
        zIndex: 0,
        borderRadius: 'inherit',
        background: 'var(--primary-8, rgba(0, 167, 111, 0.08))',
        filter: 'blur(40px)',
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-16px',
        left: '-16px',
        width: '80px',
        height: '80px',
        zIndex: 0,
        borderRadius: 'inherit',
        background: 'var(--warning-8, rgba(254, 254, 1, 0.08))',
        filter: 'blur(40px)',
      },
    },
    outlined: ({ theme }) => ({
      borderColor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
    }),
  },
};

// ----------------------------------------------------------------------

export const paper = { MuiPaper };
